export const externalLinks = {
  winnipegRealtorLink: 'https://www.realtor.ca/mb/winnipeg/real-estate',
};

export const waitListLink = 'https://www.requityhomes.com/waitlist';
